export const getCourseProgress = courseSlug => `/api/v1/member/courses/${courseSlug}`;
export const enrolCourse = hashedId => `/api/v1/member/courses/${hashedId}`;
export const archiveCourse = hashedId => `/api/v1/member/catalogue/courses/${hashedId}/archive`;
export const unarchiveCourse = hashedId => `/api/v1/member/catalogue/courses/${hashedId}/unarchive`;
export const getCourseResults = page => `/api/v1/member/courses?page=${page}`;
export const getCompletedCourses = () => `/api/v1/member/courses?relations=topics`;
export const getCoursesEnrolled = () => `/api/v1/user/courses/enrolled`;

export const getCatalogue = ({status = 'inProgress', page = 1, orderBy = 'updated_at', limit = 10}) => {
    return `/api/v1/member/catalogue?status=${status}&page=${page}&orderBy=${orderBy}&limit=${limit}`;
};


